export function reloadAllTabs() {
  localStorage.setItem('reload', Date.now().toString());
}
window.addEventListener('storage', (event) => {
  if (event.key === 'reload') {
    window.location.reload();
  }
});
